import {useSelector} from 'react-redux';
import {selectIsPremium} from '~/common/FabricInvitation/reducers/fabricTemplate/selectors';
import {GoogleAdBanner} from '~/common/fabric/GoogleAds/GoogleAdBanner';
import {selectUsedPremiumFeature} from '~/common/fabric/reducers/fabricDesign/selectors';
import {useUpsellModal} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/UpsellModal/useUpsellModal';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';

export const useAdsPanel = () => {
  const isPremium = useSelector(selectIsPremium);
  const usedPremiumFeature = useSelector(selectUsedPremiumFeature);
  const isLargishAndUp = useIsLargishAndUp();
  const {toggleUpsellModal: toggleAdsUpsellModal, UpsellModalComponent: AdsUpsellModalComponent} =
    useUpsellModal('remove-ads', 'ads');

  // Render ads panel if user is not premium
  const adsPanel =
    !isPremium && !usedPremiumFeature ? (
      <GoogleAdBanner
        configKey={isLargishAndUp ? 'createFlowDesktop' : 'createFlowMobile'}
        preview
        removeOnClick={() => toggleAdsUpsellModal('remove-ads')}
        showRemoveButton
        pageType="createflow"
      />
    ) : null;

  return {
    adsPanel,
    isPremium,
    usedPremiumFeature,
    AdsUpsellModalComponent,
  };
};
